// extracted by mini-css-extract-plugin
module.exports = {"container":"Select_container__3X9Lo","label":"Select_label__qYg15"};